import { APIService } from "@/services/api";
import { API } from "@/lib/api";
import {
  ReadPayrollDepartment,
  WritePayrollDepartment,
} from "@/types/payrollDepartment";

export const PayrollDepartmentService = new APIService<
  ReadPayrollDepartment,
  WritePayrollDepartment
>(API.PayrollDepartments);
export const fetchPayrollDepartmentList = PayrollDepartmentService.getList;
export const fetchPayrollDepartment = PayrollDepartmentService.get;
export const createPayrollDepartment = PayrollDepartmentService.post;
export const updatePayrollDepartment = PayrollDepartmentService.patch;
